export const Restore = ({ size = 20, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.2191 4.48761C12.6033 4.64233 13.0402 4.45628 13.195 4.07205C13.3497 3.68781 13.1636 3.25091 12.7794 3.09618L12.4992 3.79189L12.2191 4.48761ZM7.2191 16.9043C7.60333 17.059 8.04024 16.8729 8.19496 16.4887C8.34969 16.1045 8.16363 15.6676 7.7794 15.5128L7.49925 16.2086L7.2191 16.9043ZM8.24923 12.5002C8.24923 12.086 7.91344 11.7502 7.49923 11.7502C7.08501 11.7502 6.74923 12.086 6.74923 12.5002H7.49923H8.24923ZM7.49923 16.6669V17.4169C7.91344 17.4169 8.24923 17.0811 8.24923 16.6669H7.49923ZM3.33256 15.9169C2.91835 15.9169 2.58256 16.2527 2.58256 16.6669C2.58256 17.0811 2.91835 17.4169 3.33256 17.4169V16.6669V15.9169ZM12.4992 3.79189L12.7794 3.09618C8.9664 1.56075 4.63064 3.40708 3.09521 7.22007L3.79092 7.50023L4.48663 7.78038C5.71262 4.73584 9.17456 3.26162 12.2191 4.48761L12.4992 3.79189ZM3.79092 7.50023L3.09521 7.22007C1.55977 11.0331 3.4061 15.3688 7.2191 16.9043L7.49925 16.2086L7.7794 15.5128C4.73487 14.2869 3.26064 10.8249 4.48663 7.78038L3.79092 7.50023ZM7.49923 12.5002H6.74923V16.6669H7.49923H8.24923V12.5002H7.49923ZM7.49923 16.6669V15.9169H3.33256V16.6669V17.4169H7.49923V16.6669Z"
        fill="currentColor"
      />
      <path
        d="M15.3073 5.9667V5.97503"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8346 16.6166V16.6249"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0339 15.3085V15.3168"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1432 12.5834V12.5917"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6159 9.16689V9.17523"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
